import VuePdf from './components/VuePdf.js'

export default VuePdf
